import {Injectable} from "@angular/core";
import {ParameterRule} from "@ispm-client/modules/query-builder/models/query-builder-config";
import {FactorBaseService} from "./factor-base-service";

@Injectable()
export class RelapseService extends FactorBaseService{
  static readonly RELAPSEEVIDENCE = "relapseevidence";
  static readonly RELAPSESETTING = "relapsesetting";
  static readonly LOCATION = "location";

  public getDisplayName(parameterRule: ParameterRule) : string {
    //create a dictionary of Rules where the attribute type is the key (e.g., gene, origin)
    this.parameterRulesMap = {};
    let parameterRules = parameterRule.rules;
    for (let rule of parameterRules) {
      this.parameterRulesMap[rule.field.toLowerCase()] = rule;
    }

    //get relapse type
    let parameter: string = parameterRule.parameter.toLowerCase();
    let relapseType: string = "";
    switch (parameter.toLowerCase()) {
      case "relapserecurrenceprogression": {
        relapseType = this.relapse();
        break;
      }
    }
    return relapseType;
  }

  private relapse(): string {
    /*
    Relapse/Recurrence/Progression
    {Relapse Evidence}
    {Relapse Setting}
    {Location}
     */
    var results: string[] = new Array();

    this.relapseEvidence(results);
    this.relapseSetting(results);
    this.location(results);

    let delimitedString = results.join(RelapseService.SPACE);
    return delimitedString;
  }

  private relapseEvidence(results: string[]) {
    let rule = this.parameterRulesMap[RelapseService.RELAPSEEVIDENCE];
    if (rule) {
      let displayValue: string = rule.value.display;
      this.pushWithOperator(rule, displayValue, results);
    }
  }

  private relapseSetting(results: string[]) {
    let rule = this.parameterRulesMap[RelapseService.RELAPSESETTING];
    if (rule) {
      let displayValue: string = rule.value.display;
      this.pushWithOperator(rule, displayValue, results);
    }
  }

  private location(results: string[]) {
    let rule = this.parameterRulesMap[RelapseService.LOCATION];
    if (rule) {
      let displayValue: string = rule.value.display;
      this.pushWithOperator(rule, displayValue, results);
    }
  }
}
